//import Polyfills from './polyfills'

import "core-js/stable"
import "regenerator-runtime/runtime"
import "./styleguide/js/cph-web"
import "./uiscripts/index"
import DomFactory from "./helpers/domFactory"
import { setUserProfile } from "./hooks/userProfile"
import * as cookieNames from "./booking/constants/Cookies"
import * as cookieHelper from "./helpers/cookie"
import axios from "axios"
import * as endpoint from "./booking/constants/Endpoints"
import * as tracking from "./helpers/tracking"

export default class App {
  constructor() {
    console.log("App constructor in index.js")
    if (document.readyState !== "loading") {
      this.init()
    } else {
      document.addEventListener("DOMContentLoaded", this.init.bind(this))
    }
  }

  init() {
    this.domFactory = new DomFactory()
    this.setupUserAccountDetails()
    tracking.trackAbEvent(document.cookie)
  }

  setupUserAccountDetails() {
    const ssoToken = cookieHelper.getCookie(cookieNames.ACCESS_TOKEN)
    const hosts = document.body.dataset.hosts && JSON.parse(document.body.dataset.hosts)
    this.getUserAccountDetails(ssoToken, hosts)
  }

  getUserAccountDetails = (ssoToken, hosts) => {
    if (ssoToken && hosts) {
      axios
        .get(endpoint.ACCOUNT_DETAILS(hosts), { headers: { Authorization: "Bearer " + ssoToken } })
        .then((res) => res.data)
        .then((userAccountDetails) => {
          setUserProfile(userAccountDetails)
        })
    } else {
      setUserProfile(null)
      // Check if we have a session in the IdP
      const checkSession = cookieHelper.getCookie("CPH.CheckSession")
      if (hosts && !checkSession) {
        axios.get(endpoint.HAS_SESSION(hosts)).then((response) => {
          cookieHelper.setCookie("CPH.CheckSession", response.data)
        })
      }
    }
  }
}

// Accessibility: Dynamically manage tabindex on #main-content for iOS anchor focus
document.addEventListener("DOMContentLoaded", function () {
  const mainContent = document.getElementById("main-content")
  if (!mainContent) return

  function ensureTabindex() {
    if (!mainContent.hasAttribute("tabindex")) {
      mainContent.setAttribute("tabindex", "0")
    }
  }

  function removeTabindexIfNotFocused(e) {
    if (
      document.activeElement !== mainContent ||
      (document.activeElement.classList && document.activeElement.classList.contains("accessibility-menu-item"))
    ) {
      mainContent.removeAttribute("tabindex")
    }
  }

  document.body.addEventListener("focusin", function (e) {
    if (e.target === mainContent || (e.target.classList && e.target.classList.contains("accessibility-menu-item"))) {
      ensureTabindex()
    } else {
      removeTabindexIfNotFocused(e)
    }
  })

  mainContent.addEventListener("focusout", function () {
    setTimeout(removeTabindexIfNotFocused, 10)
  })
})

window.app = new App()
